/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { FRLoginFailure, FRStep } from "@forgerock/javascript-sdk";
import type { StringDict } from "@forgerock/javascript-sdk/src/shared/interfaces";
import { extend } from "lodash";
import type { ReactElement } from "react";



export const MessageType = {
  info: "info",
  warning: "warning",
  error: "error",
  success: "success",
  dialog: "dialog"
} as const;

export type MessageType = typeof MessageType[keyof typeof MessageType];

export interface BaseCallBackInterface extends BaseAlertDataInterface {
    step: FRStep,
    setStep: Function,
    tree: string
}


export interface BaseAlertDataInterface {
    messageType?: MessageType,
    setMessageType?: Function,
    message?: string,
    setMessage?: Function,
    isAlertOpen?: boolean,
    setIsAlertOpen?: Function
    backLink?: ReactElement
    uiStage?: string,
    fullWidthSave?: boolean
}
export interface HandleFailureStepParams extends BaseAlertDataInterface{ 
  setStep : Function,
  tree : string, 
  failStep : FRLoginFailure, 
  restartOnFailure?: boolean;
  queryParams?: Map<string, string>;
}

export type gotoAndResumeSetter ={
  setStep : Function,
  setGoto: Function,
  setRedirectURI: Function,
  tree : string,
  setMaintenancePage: Function
  queryParams?: Map<string, string>;
}